<template lang="pug">
.vgt22-menu
  ul
    li(:class="{ 'is-current': current === 'top' }")
      a.vgt22-menu-link(v-if="current === 'top'" v-scroll-to="{ el: '#top' }" data-hover="TOP")
        | トップ
      nuxt-link.vgt22-menu-link(v-else to="/vgt2022" data-hover="TOP")
        | トップ
    li(:class="{ 'is-current': current === 'timetable' }")
      nuxt-link.vgt22-menu-link(to="/vgt2022/timetable" data-hover="TIMETABLE")
        | タイムテーブル
    li(:class="{ 'is-current': current === 'speakers' }")
      nuxt-link.vgt22-menu-link(to="/vgt2022/speakers" data-hover="SPEAKERS") 登壇者
    li(:class="{ 'is-current': current === 'exhibition' }")
      nuxt-link.vgt22-menu-link(to="/vgt2022/exhibition" data-hover="EXHIBITION") 展示ブース
    //- li
      a.vgt22-menu-link(v-if="current === 'top'" v-scroll-to="{ el: '#sponsor' }" data-hover="スポンサー")
        | SPONSORS
      nuxt-link.vgt22-menu-link(v-else to="/vgt#sponsor" data-hover="スポンサー")
        | SPONSORS
</template>

<script>
export default {
  props: {
    current: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/individual/vgt/2022/vgt2022.scss';
.vgt22-menu {
  position: sticky;
  top: 0;
  @include media(pc) {
    z-index: 10;
    right: 0;
    margin-bottom: -66px;
    padding: 20px 20px 0 0;
    text-align: right;
  }
  @include media(sp) {
    z-index: 101; //tableの上
    left: 0;
    width: 100%;
    background: linear-gradient(0deg, transparent 0%, #000 100%);
  }
  @include media(pc) {
    &.is-absolute {
      position: absolute;
    }
  }
  * {
    transition: all 0.35s ease;
  }
  ul {
    @include media(pc) {
      display: inline-flex;
      justify-content: flex-end;
      box-shadow: 0 0 25px -8px rgba(#fff, 0.3);
      border: 1px solid rgba(#fff, 0.1);
    }
    @include media(sp) {
      display: flex;
      width: 100%;
      justify-content: center;
      border-bottom: 1px solid rgba($vgt_violet, 0.6);
    }
  }
  li {
    overflow: hidden;
    background: #000;
    @include media(sp) {
      flex: auto;
    }
  }
  li + li {
    @include media(pc) {
      border-left: 1px solid rgba(#fff, 0.2);
    }
    @include media(sp) {
      border-left: 1px solid rgba($vgt_violet, 0.6);
    }
  }
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 46px;
    font-weight: bold;
    text-decoration: none;
    cursor: pointer;
    color: #fff;
    letter-spacing: 1px;
    text-decoration: none;
    font-family: 'Montserrat', $font;
    @include media(sp) {
      width: 100%;
      height: 42px;
      @include fz_vw($font_size: 10);
    }
    @include media(pc) {
      width: 188px;
      font-size: 0.8em;
      &::before {
        position: absolute;
        transition: all 0.35s ease;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 100%;
        left: 0;
        content: attr(data-hover);
        white-space: nowrap;
        text-align: center;
      }
    }
  }
  @include media(pc) {
    li:hover a {
      transform: translateY(100%);
    }
  }
  .is-current {
    pointer-events: none;
    a {
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 4px;
        @include vgt_gradation();
        @include media(sp) {
          height: 3px;
        }
      }
    }
  }
}
</style>
